/* ==========================================================================
   Hadara — quotation PDF, written directly.

   No external library. PDF is a text-based format, so the document is
   assembled here and handed to the browser as a Blob download. That removes
   every dependency that could fail to upload, fail to load, or be blocked.

   Base-14 Helvetica is used, so no font embedding is needed and the file
   stays a few kilobytes.
   ========================================================================== */
window.HadaraQuotePDF = (function () {
  'use strict';

  var PW = 595.28, PH = 841.89;   /* A4 in points */
  var MM = 2.834645669;
  var M  = 13 * MM;               /* 13mm sides, matching the request-quote sheet */
  var MT = 14 * MM;               /* 14mm top and bottom */

  /* ---------- text ---------- */

  function clean(v) {
    if (v === null || v === undefined) return '';
    return String(v)
      .replace(/[\u2012-\u2015\u2212]/g, '-')
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201C\u201D]/g, '"')
      .replace(/\u2022/g, '-')
      .replace(/\u00b7/g, '|')
      .replace(/\u2026/g, '...')
      .replace(/\u00a0/g, ' ')
      .replace(/[^\x20-\x7E]/g, '');
  }
  function esc(v) {
    return clean(v).replace(/\\/g, '\\\\').replace(/\(/g, '\\(').replace(/\)/g, '\\)');
  }

  var W_REG = {' ':278,'!':278,'"':355,'#':556,'$':556,'%':889,'&':667,"'":191,'(':333,')':333,'*':389,'+':584,',':278,'-':333,'.':278,'/':278,'0':556,'1':556,'2':556,'3':556,'4':556,'5':556,'6':556,'7':556,'8':556,'9':556,':':278,';':278,'<':584,'=':584,'>':584,'?':556,'@':1015,'A':667,'B':667,'C':722,'D':722,'E':667,'F':611,'G':778,'H':722,'I':278,'J':500,'K':667,'L':556,'M':833,'N':722,'O':778,'P':667,'Q':778,'R':722,'S':667,'T':611,'U':722,'V':667,'W':944,'X':667,'Y':667,'Z':611,'[':278,'\\':278,']':278,'^':469,'_':556,'`':333,'a':556,'b':556,'c':500,'d':556,'e':556,'f':278,'g':556,'h':556,'i':222,'j':222,'k':500,'l':222,'m':833,'n':556,'o':556,'p':556,'q':556,'r':333,'s':500,'t':278,'u':556,'v':500,'w':722,'x':500,'y':500,'z':500,'{':334,'|':260,'}':334,'~':584};
  var W_BOLD = {' ':278,'!':333,'"':474,'#':556,'$':556,'%':889,'&':722,"'":238,'(':333,')':333,'*':389,'+':584,',':278,'-':333,'.':278,'/':278,'0':556,'1':556,'2':556,'3':556,'4':556,'5':556,'6':556,'7':556,'8':556,'9':556,':':333,';':333,'<':584,'=':584,'>':584,'?':611,'@':975,'A':722,'B':722,'C':722,'D':722,'E':667,'F':611,'G':778,'H':722,'I':278,'J':556,'K':722,'L':611,'M':833,'N':722,'O':778,'P':667,'Q':778,'R':722,'S':667,'T':611,'U':722,'V':667,'W':944,'X':667,'Y':667,'Z':611,'[':333,'\\':278,']':333,'^':584,'_':556,'`':333,'a':556,'b':611,'c':556,'d':611,'e':556,'f':333,'g':611,'h':611,'i':278,'j':278,'k':556,'l':278,'m':889,'n':611,'o':611,'p':611,'q':611,'r':389,'s':556,'t':333,'u':611,'v':556,'w':778,'x':556,'y':556,'z':500,'{':389,'|':280,'}':389,'~':584};

  function textWidth(str, size, bold) {
    var t = clean(str), tbl = bold ? W_BOLD : W_REG, w = 0;
    for (var i = 0; i < t.length; i++) w += (tbl[t.charAt(i)] || 556);
    return w * size / 1000;
  }
  function ellipsize(str, size, bold, maxW) {
    var t = clean(str);
    if (textWidth(t, size, bold) <= maxW) return t;
    while (t.length > 1 && textWidth(t + '...', size, bold) > maxW) t = t.slice(0, -1);
    return t + '...';
  }
  function wrap(str, size, bold, maxW) {
    var words = clean(str).split(/\s+/), lines = [], line = '';
    for (var i = 0; i < words.length; i++) {
      if (!words[i]) continue;
      var probe = line ? line + ' ' + words[i] : words[i];
      if (textWidth(probe, size, bold) > maxW && line) { lines.push(line); line = words[i]; }
      else line = probe;
    }
    if (line) lines.push(line);
    return lines;
  }

  /* ---------- drawing ---------- */

  function Doc() { this.pages = []; this.ops = []; this.images = []; }
  Doc.prototype.image = function (img, x, y, w, h) {
    var name = 'Im' + (this.images.length + 1);
    this.images.push(img);
    this.ops.push('q ' + w.toFixed(2) + ' 0 0 ' + h.toFixed(2) + ' ' +
      x.toFixed(2) + ' ' + y.toFixed(2) + ' cm /' + name + ' Do Q');
    return name;
  };
  Doc.prototype.newPage = function () { if (this.ops.length) this.pages.push(this.ops.join('\n')); this.ops = []; };
  Doc.prototype.done = function () { if (this.ops.length) this.pages.push(this.ops.join('\n')); this.ops = []; };
  Doc.prototype.rgb = function (c) { return (c[0]/255).toFixed(3)+' '+(c[1]/255).toFixed(3)+' '+(c[2]/255).toFixed(3); };
  Doc.prototype.text = function (str, x, y, opt) {
    opt = opt || {};
    var size = opt.size || 9, bold = !!opt.bold, col = opt.color || [28,26,23];
    var t = esc(str);
    if (!t) return;
    var w = textWidth(str, size, bold) + (opt.track ? opt.track * (clean(str).length - 1) : 0);
    var xx = x;
    if (opt.align === 'right') xx = x - w;
    else if (opt.align === 'center') xx = x - w/2;
    var tc = opt.track ? ' ' + opt.track.toFixed(2) + ' Tc' : ' 0 Tc';
    this.ops.push('BT /'+(bold?'F2':'F1')+' '+size+' Tf'+tc+' '+this.rgb(col)+' rg 1 0 0 1 '+
      xx.toFixed(2)+' '+y.toFixed(2)+' Tm ('+t+') Tj ET');
  };
  Doc.prototype.line = function (x1,y1,x2,y2,col,w) {
    this.ops.push(this.rgb(col||[221,216,206])+' RG '+(w||0.6)+' w '+
      x1.toFixed(2)+' '+y1.toFixed(2)+' m '+x2.toFixed(2)+' '+y2.toFixed(2)+' l S');
  };
  Doc.prototype.rect = function (x,y,w,h,fill,stroke) {
    if (fill) this.ops.push(this.rgb(fill)+' rg '+x.toFixed(2)+' '+y.toFixed(2)+' '+w.toFixed(2)+' '+h.toFixed(2)+' re f');
    if (stroke) this.ops.push(this.rgb(stroke)+' RG 0.6 w '+x.toFixed(2)+' '+y.toFixed(2)+' '+w.toFixed(2)+' '+h.toFixed(2)+' re S');
  };

  /* ---------- file assembly ---------- */

  function serialise(doc, title) {
    var pageCount = doc.pages.length, objs = [], n;
    var boldFontObj = 4 + pageCount * 2;
    var imgBase = boldFontObj + 1;
    var imgCount = (doc.images && doc.images.length) ? doc.images.length : 0;
    var infoObj = imgBase + imgCount;

    var kids = [];
    for (n = 0; n < pageCount; n++) kids.push((4 + n*2) + ' 0 R');

    objs[1] = '<< /Type /Catalog /Pages 2 0 R >>';
    objs[2] = '<< /Type /Pages /Count '+pageCount+' /Kids ['+kids.join(' ')+'] >>';
    objs[3] = '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>';

    for (n = 0; n < pageCount; n++) {
      var pi = 4 + n*2, ci = pi + 1;
      var xobj = '';
      if (doc.images && doc.images.length) {
        var parts = [];
        for (var k = 0; k < doc.images.length; k++) parts.push('/Im' + (k + 1) + ' ' + (imgBase + k) + ' 0 R');
        xobj = ' /XObject << ' + parts.join(' ') + ' >>';
      }
      objs[pi] = '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 '+PW+' '+PH+'] '+
        '/Resources << /Font << /F1 3 0 R /F2 '+boldFontObj+' 0 R >>'+xobj+' >> /Contents '+ci+' 0 R >>';
      var stream = doc.pages[n];
      objs[ci] = '<< /Length '+stream.length+' >>\nstream\n'+stream+'\nendstream';
    }
    objs[boldFontObj] = '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>';
    for (n = 0; n < imgCount; n++) {
      var im = doc.images[n];
      objs[imgBase + n] = '<< /Type /XObject /Subtype /Image /Width ' + im.w + ' /Height ' + im.h +
        ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + im.data.length +
        ' >>\nstream\n' + im.data + '\nendstream';
    }
    objs[infoObj] = '<< /Title ('+esc(title||'Quotation')+') /Producer (Hadara Technology) >>';

    var out = '%PDF-1.4\n', offsets = [];
    var max = infoObj + 1;
    for (n = 1; n < max; n++) {
      if (!objs[n]) continue;
      offsets[n] = out.length;
      out += n + ' 0 obj\n' + objs[n] + '\nendobj\n';
    }
    var xref = out.length;
    out += 'xref\n0 '+max+'\n0000000000 65535 f \n';
    for (n = 1; n < max; n++) {
      out += objs[n] ? (('0000000000'+offsets[n]).slice(-10)+' 00000 n \n') : '0000000000 65535 f \n';
    }
    out += 'trailer\n<< /Size '+max+' /Root 1 0 R /Info '+infoObj+' 0 R >>\nstartxref\n'+xref+'\n%%EOF';
    return out;
  }

  function download(str, filename) {
    var bytes = new Uint8Array(str.length);
    for (var i = 0; i < str.length; i++) bytes[i] = str.charCodeAt(i) & 0xff;
    var blob = new Blob([bytes], { type: 'application/pdf' });

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename); return;
    }
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url; a.download = filename; a.rel = 'noopener';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      if (a.parentNode) a.parentNode.removeChild(a);
      try { if (URL.revokeObjectURL) URL.revokeObjectURL(url); } catch (e) {}
    }, 1500);
  }

  /* ---------- layout ---------- */

  var GOLD  = [201,169,97];   /* #c9a961 rule and table head text */
  var INK   = [28,26,23];     /* #1c1a17 body and table head fill */
  var MUTED = [107,98,87];    /* #6b6257 labels */
  var CO    = [85,80,74];     /* #55504a contact block */
  var SUB   = [138,116,69];   /* #8a7445 eyebrow and reference */
  var NUM   = [138,130,120];  /* #8a8278 row numbers */
  var RULE  = [221,216,206];  /* #ddd8ce boxes */
  var CELL  = [230,226,217];  /* #e6e2d9 row rule */
  var ZEBRA = [250,248,245];  /* #faf8f5 */

  function money(cents, cur) {
    var v = Number(cents);
    if (!isFinite(v)) v = 0;
    var n = (v/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (cur||'AED') + ' ' + n;
  }
  function pct(v) {
    var n = Number(v);
    return isFinite(n) ? n : 0;
  }

  function build(d) {
    var doc = new Doc();
    var y = PH - MT;

    if (d.logo && d.logo.data) {
      var lh = 30;                                   /* logo height in points */
      var lw = lh * (d.logo.w / d.logo.h);
      var maxw = 150;
      if (lw > maxw) { lw = maxw; lh = lw * (d.logo.h / d.logo.w); }
      doc.image(d.logo, M, y - lh, lw, lh);
    } else {
      doc.text(d.brand || 'HADARA TECHNOLOGY', M, y - 15, { size: 17, bold: true });
      if (d.tagline) doc.text(d.tagline, M, y - 26, { size: 7, color: SUB, track: 1.5 });
    }

    var right = [d.email, d.phone, d.address, d.domain];
    if (d.trn) right.push('TRN ' + d.trn);
    var ry = y - 9;
    right.filter(Boolean).forEach(function (l) {
      doc.text(l, PW - M, ry, { size: 7.6, color: CO, align: 'right' });
      ry -= 12.2;                                   /* 7.6pt at 1.6 line-height */
    });

    y = Math.min(y - 38, ry - 2);
    doc.line(M, y, PW - M, y, GOLD, 2);             /* border-bottom: 2px solid */
    y -= 24;                                        /* margin-bottom: 18px */

    doc.text(d.docTitle || 'QUOTATION REQUEST', M, y, { size: 15, bold: true });
    y -= 13;
    doc.text('REFERENCE ' + d.reference + '   |   DATE ' + d.date,
             M, y, { size: 7.6, color: SUB, track: 1.05 });
    y -= 24;

    /* Payment milestones and the delivery period are printed by the terms
       block further down, so they are deliberately not repeated up here. */
    var fields = [
      ['Name', d.fields.name], ['Company', d.fields.company],
      ['Email', d.fields.email], ['Phone', d.fields.phone]
    ].filter(function (f) { return f[1]; });

    if (fields.length) {
      var rows = Math.ceil(fields.length / 2);
      var lineH = 13;                                  /* 8.4pt at 1.55 */
      var boxH = rows * lineH + 20;                    /* padding 12px top and bottom */
      doc.rect(M, y - boxH, PW - M*2, boxH, null, RULE);
      var half = (PW - M*2) / 2;
      fields.forEach(function (f, i) {
        var col = i % 2, row = Math.floor(i / 2);
        var x = M + 14 + col * half;                   /* padding-left 14px */
        var yy = y - 22 - row * lineH;
        doc.text(f[0], x, yy, { size: 8.4, bold: true, color: MUTED });
        doc.text(ellipsize(f[1], 8.4, false, half - 100), x + 92, yy, { size: 8.4 });
      });
      y -= boxH + 18;
    }

    var showP = !!d.showPrices;
    var cols = showP
      ? [{k:'n',w:20,a:'center'},{k:'title',w:112},{k:'sku',w:88},{k:'variant',w:72},
         {k:'qty',w:24,a:'center'},{k:'unit',w:80,a:'right'},{k:'line',w:82,a:'right'}]
      : [{k:'n',w:22,a:'center'},{k:'title',w:240},{k:'sku',w:120},{k:'variant',w:120},
         {k:'qty',w:14,a:'center'}];
    var heads = showP ? ['#','PRODUCT','MODEL','FINISH','QTY','UNIT','LINE']
                      : ['#','PRODUCT','MODEL','FINISH','QTY'];

    function tableHead(yy) {
      doc.rect(M, yy - 17, PW - M*2, 17, INK, null);
      var x = M;
      cols.forEach(function (c, i) {
        var tx = c.a === 'right' ? x + c.w - 9 : (c.a === 'center' ? x + c.w/2 : x + 9);
        doc.text(heads[i], tx, yy - 11, { size: 6.8, bold: true, color: GOLD, align: c.a || 'left', track: 1.1 });
        x += c.w;
      });
      return yy - 17;
    }

    y = tableHead(y);

    /* Order the sections, then anything unexpected, then draw each group. */
    var order = (d.sectionOrder || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    var present = [];
    (d.items || []).forEach(function (it) {
      var g = (it.section || d.otherLabel || 'Other').trim();
      if (present.indexOf(g) === -1) present.push(g);
    });
    var groups = order.filter(function (g) { return present.indexOf(g) !== -1; })
                 .concat(present.filter(function (g) { return order.indexOf(g) === -1; }));
    var grouped = groups.length > 1 || (groups.length === 1 && d.items.length > 0 && d.items[0].section);

    var rowIndex = 0;

    function groupHeader(name, yy) {
      doc.rect(M, yy - 14, PW - M*2, 14, [242,239,233], null);
      doc.text(name.toUpperCase(), M + 9, yy - 9.5,
        { size: 6.8, bold: true, color: SUB, track: 1.1 });
      return yy - 14;
    }

    function groupSubtotal(name, total, yy) {
      doc.text((d.sectionSubtotalLabel || 'Section subtotal') + ' \u2014 ' + name,
               M + 9, yy - 11, { size: 7.2, color: MUTED });
      doc.text(money(total, d.currency), PW - M - 9, yy - 11,
               { size: 8.2, bold: true, align: 'right' });
      doc.line(M, yy - 16, PW - M, yy - 16, CELL, 0.7);
      return yy - 16;
    }

    function drawItem(it, i) {
      var titleLines = wrap(it.title, 8.4, false, cols[1].w - 12);
      var varIdx = showP ? 3 : 3;
      var varLines = wrap(it.variant || '-', 8.2, false, cols[varIdx].w - 10);
      var rowH = Math.max(22, Math.max(titleLines.length, varLines.length) * 11 + 12);

      if (y - rowH < MT + 58) {
        doc.newPage();
        y = PH - MT;
        y = tableHead(y);
      }

      if (i % 2 === 1) doc.rect(M, y - rowH, PW - M*2, rowH, ZEBRA, null);

      var vals = showP
        ? [String(i+1), null, it.sku || '-', it.variant || '-', String(it.qty),
           money(it.unit, d.currency), money(it.line, d.currency)]
        : [String(i+1), null, it.sku || '-', it.variant || '-', String(it.qty)];

      var x = M;
      cols.forEach(function (c, ci) {
        var tx = c.a === 'right' ? x + c.w - 9 : (c.a === 'center' ? x + c.w/2 : x + 9);
        if (c.k === 'title') {
          titleLines.forEach(function (ln, li) { doc.text(ln, x + 9, y - 15 - li*11, { size: 8.4 }); });
        } else if (c.k === 'variant') {
          varLines.forEach(function (ln, li) { doc.text(ln, x + 9, y - 15 - li*11, { size: 8.4 }); });
        } else {
          var cellSize = (c.k === 'sku') ? 8 : 8.4;
          doc.text(ellipsize(vals[ci], cellSize, c.k === 'qty', c.w - 14), tx, y - 15,
            { size: cellSize, bold: c.k === 'qty',
              align: c.a || 'left', color: c.k === 'n' ? NUM : INK });
        }
        x += c.w;
      });

      y -= rowH;
      doc.line(M, y, PW - M, y, CELL, 0.7);
    }

    if (grouped) {
      groups.forEach(function (g) {
        var mine = (d.items || []).filter(function (it) {
          return (it.section || d.otherLabel || 'Other').trim() === g;
        });
        if (!mine.length) return;
        if (y - 40 < MT + 58) { doc.newPage(); y = PH - MT; y = tableHead(y); }
        y = groupHeader(g, y);
        var sub = 0;
        mine.forEach(function (it) {
          drawItem(it, rowIndex++);
          sub += Number(it.line) || 0;
        });
        if (showP) y = groupSubtotal(g, sub, y);
      });
    } else {
      (d.items || []).forEach(function (it, i) { drawItem(it, i); });
    }

    y -= 26;
    if (showP && d.totals) {
      if (!isFinite(Number(d.totals.total)) || Number(d.totals.total) === 0) {
        var sub = Number(d.totals.subtotal) || 0;
        var ex  = Number(d.totals.extraAmt) || 0;
        var netv = sub - ex;
        var vat = Math.round(netv * (Number(d.totals.vatPct) || 0) / 100);
        d.totals.net = isFinite(Number(d.totals.net)) && d.totals.net ? d.totals.net : netv;
        d.totals.vatAmt = isFinite(Number(d.totals.vatAmt)) && d.totals.vatAmt ? d.totals.vatAmt : vat;
        d.totals.total = netv + (Number(d.totals.vatAmt) || vat);
      }
      if (y < MT + 120) { doc.newPage(); y = PH - MT - 20; }
      var bx = PW - M - 250;
      var rows2 = [];
      if (d.totals.listTotal && d.totals.listTotal !== d.totals.subtotal) {
        rows2.push(['List price total', money(d.totals.listTotal, d.currency), 0]);
        rows2.push(['Dealer discount -' + pct(d.totals.dealerPct) + '%',
                    '- ' + money(d.totals.listTotal - d.totals.subtotal, d.currency), 0]);
      }
      rows2.push([d.labels.subtotal || 'Subtotal', money(d.totals.subtotal, d.currency), 0]);
      if (d.totals.extraPct > 0) {
        rows2.push([(d.labels.extra || 'Extra discount') + ' -' + pct(d.totals.extraPct) + '%', '- ' + money(d.totals.extraAmt, d.currency), 0]);
        rows2.push([d.labels.net || 'Net before VAT', money(d.totals.net, d.currency), 0]);
      }
      rows2.push([(d.labels.vat || 'VAT') + ' ' + pct(d.totals.vatPct) + '%', money(d.totals.vatAmt, d.currency), 0]);
      rows2.push([d.labels.total || 'Total incl. VAT', money(d.totals.total, d.currency), 1]);

      rows2.forEach(function (r) {
        if (r[2]) { doc.line(bx, y + 9, PW - M, y + 9, INK, 2); y -= 9; }
        doc.text(r[0], bx, y, { size: r[2] ? 10 : 8.6, bold: !!r[2], color: r[2] ? INK : MUTED });
        doc.text(r[1], PW - M, y, { size: r[2] ? 10 : 8.6, bold: !!r[2], align: 'right' });
        y -= r[2] ? 18 : 14;
      });
    }

    if (d.fields.message) {
      y -= 10;
      if (y < MT + 70) { doc.newPage(); y = PH - MT - 20; }
      doc.text('NOTES', M, y, { size: 6.8, bold: true, color: SUB, track: 1.1 });
      y -= 12;
      wrap(d.fields.message, 8.4, false, PW - M*2).forEach(function (ln) {
        doc.text(ln, M, y, { size: 8.4 });
        y -= 11;
      });
    }

    /* ---------- terms and conditions ----------
       Two shapes are accepted. d.termsDoc is the structured document produced
       by quote-terms.js: headed sections, wrapped paragraphs, bulleted lists
       and numbered payment stages, followed by bank details. d.terms is the
       older flat array, kept so nothing breaks if the engine is absent.
       Either way the block flows onto as many pages as it needs. */
    if (d.termsDoc && d.termsDoc.blocks && d.termsDoc.blocks.length) {
      y -= 14;
      if (y < MT + 90) { doc.newPage(); y = PH - MT - 10; }

      var tdTitle = (d.termsDoc.title || d.termsTitle || 'Terms & Conditions').toUpperCase();

      function tdHeading(cont) {
        doc.text(tdTitle + (cont ? ' (CONTINUED)' : ''), M, y,
                 { size: 6.8, bold: true, color: SUB, track: 1.1 });
        y -= 6;
        doc.line(M, y, PW - M, y, RULE, 0.7);
        y -= 14;
      }
      function room(need) {
        if (y - need < MT + 26) {
          doc.newPage();
          y = PH - MT - 10;
          tdHeading(true);
        }
      }
      tdHeading(false);

      var bulletX = M + 11;
      var bulletW = PW - M * 2 - 11;

      d.termsDoc.blocks.forEach(function (blk, bi) {
        if (bi > 0) y -= 5;

        var bodyLines = [];
        (blk.lines || []).forEach(function (ln) {
          wrap(ln, 7.6, false, PW - M * 2).forEach(function (w) { bodyLines.push(w); });
        });
        var need = 13 + bodyLines.length * 10.2 + (blk.bullets || []).length * 10.2;
        room(Math.min(need, 46));

        if (blk.title) {
          doc.text(blk.title.toUpperCase(), M, y, { size: 6.6, bold: true, color: SUB, track: 0.9 });
          y -= 11;
        }

        bodyLines.forEach(function (ln) {
          if (y < MT + 22) { doc.newPage(); y = PH - MT - 10; tdHeading(true); }
          doc.text(ln, M, y, { size: 7.6, color: INK });
          y -= 10.2;
        });

        (blk.bullets || []).forEach(function (item) {
          var lines = wrap(item, 7.6, false, bulletW);
          if (y - lines.length * 10.2 < MT + 22) { doc.newPage(); y = PH - MT - 10; tdHeading(true); }
          doc.text('\u2013', M, y, { size: 7.6, color: SUB });
          lines.forEach(function (ln) {
            if (y < MT + 22) { doc.newPage(); y = PH - MT - 10; tdHeading(true); }
            doc.text(ln, bulletX, y, { size: 7.6, color: INK });
            y -= 10.2;
          });
        });

        y -= 4;
      });

      /* ---- bank details ---- */
      var bank = d.termsDoc.bank;
      if (bank && bank.rows && bank.rows.length) {
        var boxH = 20 + bank.rows.length * 11;
        if (y - boxH < MT + 26) { doc.newPage(); y = PH - MT - 10; }
        y -= 8;
        doc.line(M, y, PW - M, y, RULE, 0.7);
        y -= 13;
        doc.text((bank.title || 'BANK DETAILS FOR PAYMENT').toUpperCase(), M, y,
                 { size: 6.6, bold: true, color: SUB, track: 0.9 });
        y -= 12;
        bank.rows.forEach(function (r) {
          if (y < MT + 22) { doc.newPage(); y = PH - MT - 10; }
          doc.text(r[0], M, y, { size: 7.4, color: MUTED });
          doc.text(String(r[1]), M + 118, y, { size: 7.4, bold: true, color: INK });
          y -= 11;
        });
      }

    } else if (d.terms && d.terms.length) {
      y -= 14;
      if (y < MT + 90) { doc.newPage(); y = PH - MT - 10; }

      function termsHeading(cont) {
        doc.text((d.termsTitle || 'TERMS & CONDITIONS').toUpperCase() + (cont ? ' (CONTINUED)' : ''),
                 M, y, { size: 6.8, bold: true, color: SUB, track: 1.1 });
        y -= 6;
        doc.line(M, y, PW - M, y, RULE, 0.7);
        y -= 13;
      }
      termsHeading(false);

      var numW = 16;
      d.terms.forEach(function (clause, i) {
        var lines = wrap(clause, 7.4, false, PW - M * 2 - numW);
        /* start a new page rather than split a short clause across the break */
        if (y - (lines.length * 9.8) < MT + 26) {
          doc.newPage();
          y = PH - MT - 10;
          termsHeading(true);
        }
        doc.text((i + 1) + '.', M, y, { size: 7.4, color: SUB });
        lines.forEach(function (ln, li) {
          if (y < MT + 20) { doc.newPage(); y = PH - MT - 10; }
          doc.text(ln, M + numW, y, { size: 7.4, color: INK });
          y -= 9.8;
        });
        y -= 3.5;
      });
    }

    doc.done();

    var total = doc.pages.length;
    for (var p = 0; p < total; p++) {
      var f = new Doc();
      f.line(M, MT + 22, PW - M, MT + 22, RULE, 0.7);
      wrap(d.footer || '', 7, false, PW - M*2 - 60).slice(0, 2).forEach(function (ln, li) {
        f.text(ln, M, MT + 10 - li*11, { size: 7, color: MUTED });
      });
      f.text((p+1) + ' / ' + total, PW - M, MT + 10, { size: 7, color: MUTED, align: 'right' });
      doc.pages[p] += '\n' + f.ops.join('\n');
    }

    return doc;
  }

  /* Read a JPEG as a binary string so it can be embedded directly as a
     DCTDecode image object. No canvas, so no CORS tainting and no re-encoding. */
  function fetchJPEG(url) {
    return new Promise(function (resolve) {
      if (!url) return resolve(null);
      try {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'arraybuffer';
        xhr.timeout = 4000;
        xhr.onload = function () {
          if (xhr.status < 200 || xhr.status >= 300) return resolve(null);
          try {
            var bytes = new Uint8Array(xhr.response);
            var bin = '';
            for (var i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
            var dim = jpegSize(bytes);
            resolve(dim ? { data: bin, w: dim.w, h: dim.h } : null);
          } catch (e) { resolve(null); }
        };
        xhr.onerror = function () { resolve(null); };
        xhr.ontimeout = function () { resolve(null); };
        xhr.send();
      } catch (e) { resolve(null); }
    });
  }

  /* Width and height come from the JPEG's SOF marker. */
  function jpegSize(b) {
    var i = 2;
    while (i < b.length) {
      if (b[i] !== 0xFF) { i++; continue; }
      var m = b[i + 1];
      if (m >= 0xC0 && m <= 0xCF && m !== 0xC4 && m !== 0xC8 && m !== 0xCC) {
        return { h: (b[i + 5] << 8) | b[i + 6], w: (b[i + 7] << 8) | b[i + 8] };
      }
      i += 2 + ((b[i + 2] << 8) | b[i + 3]);
    }
    return null;
  }

  function generate(data, cfg, onProgress) {
    var note = onProgress || function () {};
    return new Promise(function (resolve, reject) {
      try {
        note('building');
        var doc = build(data);
        note('saving');
        download(serialise(doc, data.docTitle), data.filename || 'quotation.pdf');
        resolve(true);
      } catch (e) { reject(e); }
    });
  }

  return { generate: generate, _build: build, _serialise: serialise };
})();
